import type { Achievement } from "../achievement.types";
import { allMoves } from "../moveHistory";

export const goldStandardAchievement: Achievement = {
  id: "goldStandard",
  name: "Gold Standard",
  icon: "medal-outline",
  description: "Won along the gold path exactly.",
  isProgressive: true,
  // Every move made, backtracked ones included, is Global Optimal, and there
  // are exactly par of them, so it is a strict subset of Straight and Narrow.
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport?.optimalPath?.length) return false;
    const moves = allMoves(gameReport);
    return (
      moves.length > 0 &&
      moves.length === gameReport.optimalPath.length - 1 &&
      moves.every((m) => m.isGlobalOptimal === true)
    );
  },
};
